import { CartLinesUpdateEvent } from '@shopify/events';

function money(cents, format) {
  format = format || '{{amount}} €';
  return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
    var noDecimals = key.indexOf('no_decimals') !== -1;
    var value = noDecimals ? String(Math.round(cents / 100)) : (cents / 100).toFixed(2);
    if (key.indexOf('comma_separator') !== -1) value = value.replace('.', ',');
    if (key.indexOf('apostrophe_separator') !== -1) value = value.replace('.', "'");
    return value;
  });
}

function initSection(root) {
  var sectionEl = root.closest('[id^="shopify-section-"]');
  var sid = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
  var data = (window.wlbProductData || {})[sid] || {};
  var basePrice = data.basePrice || 0;
  var moneyFormat = data.moneyFormat || '{{amount}} €';
  var qtyEl = root.querySelector('[data-wlb-qty]');
  var qtyInput = root.querySelector('[data-wlb-qty-input]');
  var ctaLabel = root.querySelector('[data-wlb-cta-label]');
  var stickyTotal = root.querySelector('[data-wlb-total]');
  var msgEl = root.querySelector('[data-wlb-msg]');
  var priceEl = root.querySelector('[data-wlb-price]');
  var idInput = root.querySelector('.wlb-pdp__form input[name="id"]');
  var qty = parseInt((qtyEl && qtyEl.textContent) || '1', 10) || 1;
  var adding = false;

  // Kein Mengenrabatt: angezeigter Preis = Einzelpreis x Menge, genau wie im Warenkorb.
  function render() {
    var total = Math.round(basePrice * qty);
    if (qtyEl) qtyEl.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
    if (ctaLabel) ctaLabel.textContent = 'In den Warenkorb · ' + money(total, moneyFormat);
    if (stickyTotal) stickyTotal.textContent = money(total, moneyFormat);
  }
  var decBtn = root.querySelector('[data-wlb-dec]');
  var incBtn = root.querySelector('[data-wlb-inc]');
  if (decBtn) decBtn.addEventListener('click', function () { qty = Math.max(1, qty - 1); render(); });
  if (incBtn) incBtn.addEventListener('click', function () { qty = Math.min(999, qty + 1); render(); });

  // Variantenwahl (z. B. Gutscheinbetrag)
  var variantBtns = root.querySelectorAll('[data-wlb-variant]');
  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      data.variantId = parseInt(btn.getAttribute('data-wlb-variant'), 10);
      basePrice = parseInt(btn.getAttribute('data-price'), 10) || 0;
      if (idInput) idInput.value = data.variantId;
      if (priceEl) {
        priceEl.textContent = btn.getAttribute('data-price-text');
        priceEl.setAttribute('data-unit-price', basePrice);
      }
      variantBtns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', data.variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      render();
    });
  });

  var thumbs = root.querySelectorAll('[data-wlb-thumb]');
  var mainImg = root.querySelector('.wlb-pdp__gallery-img');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (mainImg) mainImg.src = btn.getAttribute('data-wlb-thumb');
    });
  });

  function addToCart() {
    if (!data.variantId || adding) return;
    adding = true;
    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add.js';
    var created = CartLinesUpdateEvent.createPromise();

    // Standard-Event VOR dem Request dispatchen: Drawer/Icon/Items-Komponenten
    // des Themes hängen sich an event.promise und übernehmen Re-Render + Auto-Open.
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: data.variantId, quantity: qty }],
      promise: created.promise
    }));

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: data.variantId, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart add failed: ' + r.status);
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        created.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartData) });
        if (msgEl) {
          msgEl.textContent = qty + (data.isGiftCard ? ' × Gutschein' : ' Fl.') + ' in den Warenkorb gelegt ✓';
          setTimeout(function () { msgEl.textContent = ''; }, 2500);
        }
      })
      .catch(function () {
        created.resolve({ cart: null, detail: { didError: true } });
        if (msgEl) msgEl.textContent = 'Fehler beim Hinzufügen. Bitte erneut versuchen.';
      })
      .finally(function () { adding = false; });
  }

  function addAndCheckout() {
    if (!data.variantId || adding) return;
    adding = true;
    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add.js';
    if (msgEl) msgEl.textContent = 'Weiter zur Kasse …';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: data.variantId, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart add failed: ' + r.status);
        window.location.href = '/checkout';
      })
      .catch(function () {
        adding = false;
        if (msgEl) msgEl.textContent = 'Fehler beim Weiterleiten. Bitte erneut versuchen.';
      });
  }
  var checkoutBtn = root.querySelector('[data-wlb-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', addAndCheckout);

  var stickyAddBtn = root.querySelector('[data-wlb-add]');
  if (stickyAddBtn) stickyAddBtn.addEventListener('click', addToCart);

  var form = root.querySelector('.wlb-pdp__form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
  }

  render();
}

document.querySelectorAll('.wlb-pdp').forEach(function (root) {
  initSection(root);
  var bar = root.querySelector('.wlb-pdp__stickybar');
  var buybox = root.querySelector('.wlb-pdp__buybox');
  if (bar && buybox && 'IntersectionObserver' in window) {
    bar.style.opacity = '0';
    bar.style.pointerEvents = 'none';
    bar.style.transition = 'opacity .2s';
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        bar.style.opacity = show ? '1' : '0';
        bar.style.pointerEvents = show ? 'auto' : 'none';
      });
    }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 });
    obs.observe(buybox);
  }
});
